import type { User } from "~/entities/user/types";
import axiosInstance from "~/shared/api/axios-instance";

const API_URL = "account/meta-info/";

interface UserResponse {
  email: string;
  name: string;
  is_staff: boolean;
  client: {
    uid: string;
    name: string;
  };
}

export const fetchUser = async (): Promise<User> => {
  const { data } = await axiosInstance.get<UserResponse>(API_URL);

  return {
    name: data.name,
    email: data.email,
    isStaff: data.is_staff,
    client: {
      uid: data.client.uid,
      name: data.client.name,
    },
  };
};
